'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const BaseModel = require('./BaseModel');

/**
 * Base carousel view component. "Concrete" carousel views should not extend from this class but should instead wrap it.
 * The model should be initialized in the "child" classes in the `componentWillMount` lifecycle callback.
 * @class
 */
class BaseCarousel extends React.Component {
    componentDidMount() {
        // Pass the `el` to the view-model
        this.props.model.onMount(this.refs.list);
    }

    componentWillUnmount() {
        // Do any view-model cleanup.
        this.props.model.destroy();
    }

    /**
     * Wraps the passed in children in an `li` so we can apply additional styles to the items.
     * @return {Array}
     */
    _getChildren() {
        return React.Children.map(this.props.children, (child, i) => {
            const {model, classNames = {}} = this.props;
            const style = {};
            const className = classnames('base-carousel-item', {
                [classNames.item]: classNames.item
            });

            // Get any item styles specified by the view-model.
            model.transformItemStyle(style, i);

            return <li style={style} className={className}>{child}</li>;
        });
    }

    render() {
        const {model, classNames = {}} = this.props;
        const style = {};
        const className = classnames('base-carousel-list', {
            [classNames.list]: classNames.list
        });

        // Get any styles specified by the view-model.
        model.transformListStyle(style);

        return <ul ref="list" style={style} className={className}>{this._getChildren()}</ul>;
    }
}

BaseCarousel.propTypes = {
    // View model derived from `BaseModel`
    model: PropTypes.instanceOf(BaseModel).isRequired,
    children: PropTypes.node,
    classNames: PropTypes.shape({
        // className to add to the `ul`
        list: PropTypes.string,
        // className to add to each item's `li`
        item: PropTypes.string
    })
};

module.exports = BaseCarousel;



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/base/BaseCarousel.jsx